import React from 'react';
import { Target, Users, AlertTriangle } from 'lucide-react';

const ObjectivesTab = ({ documentData = {}, analysisResults = {} }) => {
  const objectives = analysisResults?.objectives || documentData.analysis?.objectives || [];
  const targetAudience = documentData.metadata?.targetAudience || documentData.analysis?.targetAudience || '';
  const relevantPassages = documentData.metadata?.relevantPassages || documentData.analysis?.relevantPassages || [];

  return (
    <div className="space-y-8">
      {/* Public cible */}
      {targetAudience && (
        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <div className="bg-blue-100 p-2 rounded-lg">
              <Users className="h-5 w-5 text-blue-700" />
            </div>
            <div>
              <h3 className="text-base font-medium text-blue-800 mb-1">Public cible</h3>
              <p className="text-blue-700">{targetAudience}</p>
            </div>
          </div>
        </div>
      )}

      {/* Liste des objectifs */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Target className="h-5 w-5 text-blue-500" />
          <h3 className="text-lg font-medium text-gray-900">Objectifs du document</h3>
        </div>
        
        {objectives.length > 0 ? (
          <div className="space-y-3">
            {objectives.map((objective, index) => (
              <div 
                key={index} 
                className={`p-4 ${
                  index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                } border border-gray-100 rounded-lg`}
              >
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 text-blue-800 h-6 w-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium">{index + 1}</span>
                  </div>
                  <div>
                    <h4 className="text-base font-medium text-gray-900">
                      {typeof objective === 'object' ? objective.description : objective}
                    </h4>
                    
                    {typeof objective === 'object' && objective.details && (
                      <p className="text-gray-600 mt-2">{objective.details}</p>
                    )}
                    
                    {typeof objective === 'object' && objective.importance && (
                      <span className={`inline-block mt-2 px-3 py-1 text-xs rounded-full ${
                        objective.importance === 'high' 
                          ? 'bg-red-100 text-red-700' 
                          : objective.importance === 'medium'
                            ? 'bg-yellow-100 text-yellow-700'
                            : 'bg-gray-100 text-gray-700'
                      }`}>
                        Priorité: {objective.importance}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-600" />
            <p className="text-yellow-700">Aucun objectif identifié pour ce document</p>
          </div>
        )}
      </div>

      {/* Passages pertinents liés aux objectifs */}
      {relevantPassages.length > 0 && (
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Extraits clés associés aux objectifs
          </h3>
          
          <div className="space-y-4">
            {relevantPassages.map((passage, index) => (
              <div 
                key={index}
                className="p-4 bg-gray-50 border border-gray-100 rounded-lg hover:shadow-sm transition-shadow"
              >
                <div className="flex items-start gap-3">
                  <div className="bg-gray-200 text-gray-600 h-6 w-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium">{index + 1}</span>
                  </div>
                  <p className="text-gray-700">
                    {typeof passage === 'object' ? passage.content : passage}
                  </p>
                </div>
                {typeof passage === 'object' && passage.page && (
                  <div className="ml-9 mt-2">
                    <span className="inline-block px-2 py-1 text-xs bg-yellow-50 text-yellow-700 rounded-full">
                      Page {passage.page}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ObjectivesTab; 